
export default {
  getAssets: function() {
    return axios.get('/send-freight/tracker/business');
  }
}